/** Where users ask for AI agent (MCP) access (the `mcpAccess` claim is admin-granted). Shared by the Connect pages. */
export const MCP_ACCESS_REQUEST_EMAIL = 'info@30to80.com';
